import { useQuery } from '@tanstack/react-query';

import type { DonationsPublicDonationQuery } from '@/core/types/donation';

interface ValidateTagsRequest {
  tags: string[];
  queryParams?: Partial<DonationsPublicDonationQuery>;
}

interface ValidateTagsResponse {
  validTags: string[];
}

const validateTags = async (request: ValidateTagsRequest): Promise<ValidateTagsResponse> => {
  const response = await fetch('/api/univers/validate-tags', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(request),
  });

  if (!response.ok) {
    throw new Error('Failed to validate tags');
  }

  return response.json();
};

export const useValidatedTags = (tags: string[], queryParams?: Partial<DonationsPublicDonationQuery>) => {
  return useQuery({
    queryKey: ['validated-tags', tags, queryParams],
    queryFn: () => validateTags({ tags, queryParams }),
    enabled: tags.length > 0,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
};
